import React, {Component} from 'react';
import {connect} from 'react-redux';
import webp from '../../utils/webp';
import { observer, inject } from "mobx-react";

class LazyImg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible:false,
    };
  }

  componentDidMount() {
    if("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const {isIntersecting,intersectionRatio} = entry;
            if (isIntersecting || typeof isIntersecting === 'undefined') {
              this.setState({ visible: true });
              /*if(this.element) {
                this.element.src = webp(this, this.props.src);
              }*/
              if(this.observer) {
                this.observer = this.observer.disconnect();
              }

            }
          });
        },
        {
          threshold:[0.1,0.25],
          //root: document.querySelector(".container"),
          /*rootMargin: "200px 0px 200px 0px",*/
        }
      );
      this.observer.observe(this.element);
    } else {
      this.element.src = this.props.src;
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.src !== this.props.src) {
      if(this.element) {
        this.element.src = webp(this, this.props.src);
      }
    }
  }

  render() {
    if(this.state.visible) {
      return (
        <img src={webp(this, this.props.src)} className={this.props.className} style={this.props.style} alt={this.props.alt} {...this.props.passProps || {}} />
      )
    }
    return (
      <img src={"data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="} ref={el => this.element = el} className={` ${this.props.className} ${this.props.hiddenClassName}`} style={this.props.style} alt={this.props.alt} {...this.props.passProps || {}} />
    )
  }
}



function mapStateToProps(state) {
  return {
    webp:state.webp,
  }
}


export default inject("appStateStore")(observer(LazyImg));